import clsx from "clsx";
import React, { FC, useState } from "react";

import { AutocompleteForm, TrianglePicture } from "../../../common/components";
import {
  ContentfulEntry,
  ContentfulPicture,
  WithContext,
} from "../../../common/interfaces";

import styles from "./styles.module.scss";

const AssemblyMap: FC<WithContext> = ({ context }) => {
  const sectionData = context["Paragraph > Australia-wide installations"];
  const link: ContentfulEntry = context["Link > Book an Install"];
  const [locationStatus, setLocationStatus] = useState(false);

  const installationMap = (sectionData?.pictures as ContentfulPicture[])?.find(
    ({ title }) => title.includes("Desktop")
  );

  return (
    <section className={styles.root}>
      <TrianglePicture color="blue" />
      <div className={clsx("row", styles.content)}>
        <div className="col-md-5 offset-md-1">
          <img
            src={installationMap?.file}
            className={clsx("lazyload", styles.map)}
            alt="Installation map"
          />
        </div>

        <div className={clsx("col-md-5", styles.form)}>
          <h3>{sectionData?.headline}</h3>

          <p className={styles.subtitle}>{sectionData?.subheadline}</p>

          {/* Below is commented out until we are able to identify postcodes where we can install vs deliver.  */}

          {/* {!locationStatus ? (
            <p className={styles.caption}>{sectionData?.paragraph}</p>
          ) : (
            ""
          )} */}

          {/* <AutocompleteForm
            installBtnText={link?.headline}
            installBtnUrl={link?.url}
            locationStatus={locationStatus}
            setLocationStatus={setLocationStatus}
          /> */}

          {link?.headline && link?.url ? (
            <div className={clsx(styles.installBtnDiv)}>
              <button
                className={clsx(styles.btnInstall)}
                onClick={() => window.open(link?.url, "_blank")}
                rel="noopener noreferrer"
              >
                {link?.headline}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
};

export default AssemblyMap;
